<template>
  <v-card class="mx-auto" tile
    :style="$vuetify.breakpoint.xl ? 'height: calc(100vh - 98px)' : 'height: calc(100vh - 66px)'">
    <v-navigation-drawer touchless src="@/assets/tbmsidebar.png" dark permanent style="width: 100%">
      <div class="d-flex flex-column justiy-space-between" style="height: 100%">
        <div>
          <v-toolbar color="#F54B88" dark>
            <v-toolbar-title class="text-body-1 text-xl-h5 font-weight-bold" elevation="0">BETSLIP<br />
              <h6 v-if="showPlayerCard" elevation="0">
                Player Id: {{ this.playerCardId || "Not Entered" }}
              </h6>
            </v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
        </div>
        <div class="flex-grow-1 betContainer" style="overflow-y: scroll; box-sizing: content-box" ref="betContainerEl">
          <div>
            <v-list v-if="getBetSlip">
              <v-list-item v-for="(item, i) in getBetSlip" :key="i" link
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)" @click="openBetEditor(item.selId)">
                <v-list-item-content class="text-xl-body-1">
                  <v-list-item-title class="float-left font-weight-bold">{{ item.runnerNumber }}. {{ item.runnerName }}
                    <div class="d-inline raceTypeDiv">
                      <MeetingIcon :meeting="item.meeting" class="raceIcon" :inverse="true" />
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ item.trackName }} R{{ item.trackNumber }} -
                    {{ item.trackCountry }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="overline">{{
                    formatStartTime(moment(item.startTime))
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="white--text"><span style="color: #00e676; margin-right: 10px">{{
                    betype(item.winPlc)
                  }}</span>
                    <span style="color: #dce775">{{ ticketStatusName("Stake") }}:</span>
                    ${{ item.stake }}
                    <span style="color: #29b6f6; margin-left: 10px">Odds:</span>
                    ${{ item.odds }}
                    <span class="ml-3" v-if="$vuetify.breakpoint.xl">Potential Return:<span
                        class="ml-1 success--text ">${{
                          potentialReturn(item.stake, item.odds)
                        }}</span></span>

                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xl" class="white--text"><span>Potential Return:</span>
                    ${{
                      potentialReturn(item.stake, item.odds)
                    }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <div class="flex-grow-0 flex-shrink-0 d">
          <div class="ma-2">
            <v-btn v-if="isOverFlowing" elevation="0" class="float-left mb-1" width="110px" color="#465169" small
              :large="$vuetify.breakpoint.xl" dark @click="scrollTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
            <v-btn v-if="isOverFlowing" elevation="0" class="float-right mb-1" width="110px" color="#465169" small
              :large="$vuetify.breakpoint.xl" dark @click="scrollDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
          </div>
          <div style="clear: both"></div>
          <v-card color="#465169" tile width="100%">
            <v-card-title>
              <span class="d-inline">Slip Total:</span>
              <span class="d-inline" style="color: #00e676">
                ${{ totalRequest }}</span>
            </v-card-title>
          </v-card>
        </div>
      </div>
      <template v-slot:append>
        <div class="pa-2" style="text-align: center">
          <v-btn elevation="0" x-large width="100%" class="mb-2" @click="cancelBets()" color="#465169"
            :disabled="totalRequest === 0">
            <span class="display-1">Clear Slip</span>
          </v-btn>
          <v-btn elevation="0" width="100%" x-large @click="sendBets()" color="success" :disabled="totalRequest === 0">
            <span class="display-1">Total &amp; Pay</span>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <BetSlipEditor v-if="showBetEditor" @close="closeBetEditor()" :editBetId="editBetId" />
    <v-dialog v-model="showSendBets" :max-width="$vuetify.breakpoint.xl ? 1300 : 900" persistent>
      <v-card color="background">
        <v-card-title class="px-0"><v-btn elevation="0" fab color="error" x-small class="modal-default-button ma-4 mb-0"
            :disabled="processing || !allBetsPrinted" @click="
              showSendBets = false;
            handleCancelBets();
                          ">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-0">
          <v-row no-gutters>
            <v-col cols="6">
              <div class="d-flex" style="height:48px">
                <h3 class="pa-2 pb-0 ">Betslip</h3>
                <v-spacer></v-spacer>
                <div class="ma-2 ">
                  <v-btn v-if="isBetSlipOverFlowing" elevation="0" class=" mb-1 mr-3" width="110px" color="#465169" small
                    dark @click="scrollBetSlipTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-btn v-if="isBetSlipOverFlowing" elevation="0" class=" mb-1" width="110px" color="#465169" small dark
                    @click="scrollBetSlipDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
                </div>
              </div>
              <v-list dense color="#232D3F" class="betslipList mr-1" ref="betSlipListEl"
                style="height:calc(90vh - 220px)">
                <v-list-item-group dark>
                  <div v-for="(item, i) in betsSent || betslip" :key="i">
                    <v-list-item v-if="(item.status === 'pending' || !item.status || item.status === 'unresulted') && !betIsPrinted(item)">
                      <v-list-item-content>
                        <div>
                          <div class="float-left">
                            <v-list-item-title class="font-weight-bold mr-4">{{ item.runnerNumber }}.
                              {{ item.runnerName }}</v-list-item-title>
                            <v-list-item-subtitle class="d-inline mr-5">{{ item.trackName }} R{{ item.trackNumber }} -
                              {{ item.trackCountry }}</v-list-item-subtitle>
                            <v-list-item-subtitle class="overline">{{
                              formatStartTime(moment(item.startTime))
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle><span style="color: #00e676; margin-right: 10px">{{ betype(item.winPlc)
                            }}</span>
                              <span style="color: #dce775">{{
                                ticketStatusName("Stake")
                              }}</span>
                              ${{ item.stake }}
                              <span style="color: #29b6f6; margin-left: 10px">Odds:</span>
                              ${{ item.odds }}
                              <span class="ml-3" v-if="$vuetify.breakpoint.xl">Potential Return:<span
                                  class="ml-1 success--text ">${{
                                    potentialReturn(item.stake, item.odds)
                                  }}</span></span> </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="!$vuetify.breakpoint.xl" class="white--text"><span>Potential
                                Return:</span> ${{
                                  potentialReturn(item.stake, item.odds)
                                }}</v-list-item-subtitle>
                          </div>
                          <div class="float-right">
                            <div v-if="item.status && item.status !== 'unresulted'">
                              <v-chip>
                                {{ item.status }}
                                <v-progress-circular class="ml-3" indeterminate color="white"
                                  :size="15"></v-progress-circular>

                              </v-chip>
                            </div>

                            <div v-else-if="item.status && item.status === 'unresulted' && !betIsPrinted(item)">
                              <v-chip>
                                Sending bet
                                <v-progress-circular class="ml-3" indeterminate color="white"
                                  :size="15"></v-progress-circular>

                              </v-chip>
                            </div>

                            <div v-else>
                              <v-chip color="#7B8294"><span class="text-body-1 px-2">Unsent</span></v-chip>

                            </div>
                            <v-btn elevation="0" v-if="
                              allowCancelPendingBets &&
                              item.status === 'pending'
                            " class="float-right mt-5" @click="cancelPendingBet(item)" color="warning">Cancel</v-btn>
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </div>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-col cols="6">
              <div class="d-flex" style="height:48px">
                <h3 class="pa-2 pb-0 ">Processed Bets</h3>
                <v-spacer></v-spacer>
                <div class="ma-2">
                  <v-btn v-if="isBetSlipProcessedOverFlowing" elevation="0" class="mb-1 mr-3" width="110px"
                    color="#465169" small dark @click="scrollProcessedTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-btn v-if="isBetSlipProcessedOverFlowing" elevation="0" class="mb-1" width="110px" color="#465169"
                    small dark @click="scrollProcessedDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
                </div>
              </div>

              <v-list dense color="#232D3F" class="betslipListProcessed" ref="betSlipProcessedEl"
                style="height:calc(90vh - 220px)">
                <v-list-item-group dark>
                  <v-list-item v-for="data in betsCompleted" :key="data.key">
                    <BetConfirmations :resendBet="resendBet" :ticketStatusName="ticketStatusName" :moment="moment"
                      :formatStartTime="formatStartTime" :data="data" :loading="processing"
                      :printProcessedBet="addPrintQueue" :clearProcessedBet="clearProcessedBet" />
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions style="z-index: 999" class="d-flex ">
          <div>
            <div v-if="!betsPlaced && showPlayerCard" class="caption font-weight-bold pb-0 pt-1">Player Id: {{
              this.playerCardId || "Not Entered" }}</div>
            <div v-if="!betsPlaced" class="headline font-weight-bold d-inline">Total to pay: ${{ totalRequest }}</div>
            <div v-if="betsPlaced && !processing && totalRefund !== '0.00'" class="headline font-weight-bold d-inline">Total to refund:
              <span class="refund">${{ totalRefund }}</span>
            </div>
          </div>
          <v-spacer></v-spacer>
          <div v-if="!betsPlaced" class="d-flex">
            <v-btn elevation="0" color="success" x-large class="mr-2" @click="placeBet()">
              Payment received <br />
              send bets
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn elevation="0" x-large color="error" @click="cancelBets('Operator Cancelled')">
              Cancel bets <br />clear betslip
            </v-btn>
          </div>
          <div v-if="betsPlaced && !printingAllBets" class="d-flex">
            <!-- <div>Total to refund: ${{totalRefund}}</div> -->
            <v-btn elevation="0" x-large :disabled="!allBetsPrinted" color="error" @click="cancelBets()">
              Clear Bets And Close
            </v-btn>
          </div>
          <v-progress-circular class="ma-4" v-if="printingAllBets" indeterminate :size="15"
            color="primary"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";
import MeetingIcon from "./MeetingIcon";
import BetSlipEditor from "./BetSlipEditor";
import { mapBetSlip } from "../store/index";
import BetConfirmations from "./BetConfirmations";
import moment from "moment";
import { NAMINGS, PRICE_DISPLAY } from "../common/constants";
import {
  generateCustomerBetReceipt,
  generateTellerRefundReceipt,
} from "../common/tickets";
import Vue from "vue";
import { PLAYERCARDACTIVE } from "../common/constants";
import { updateCustomerDisplayStoredBets } from "../common/customerDisplay";

export default {
  data() {
    return {
      checkBetPoll: null,
      betId: [],
      stake: 0,
      interval: {},
      value: 0,
      loadCircle: false,
      error: null,
      betStatus: null,
      betDetails: null,
      refundBet: 0,
      showSendBets: false,
      checkMark: false,
      betMessage: "",
      betPollingInterval: null,
      showBetEditor: false,
      editBetId: null,
      betsPlaced: false,
      printingAllBets: false,
      printQueue: {},
      printing: false,
      allowCancelPendingBets: false,
      betTimeoutMap: [],
      betContainerClientHeight: 0,
      betContainerScrollHeight: 0,
      betSlipListElClientheight: 0,
      betSlipListElScrollHeight: 0,
      betSlipProcessedElClientheight: 0,
      betSlipProcessedElScrollHeight: 0
    };
  },
  props: {
    clearStake: Function,
    ticketId: String,
    ticketIdChange: Function,
    rejectedTicket: Function,
    betDetailsChecked: Function,
  },
  components: {
    MeetingIcon,
    BetConfirmations,
    BetSlipEditor,
  },
  computed: {
    ...mapGetters([
      "getBetSlip",
      "getTerminalId",
      "getStoredPayment",
      "getProcessingBets",
      "getVenueName",
      "getTerminalLocation",
      "hasFeature",
      "getProcessedBets"
    ]),
    ...mapState(["processedBets", "processingBets", "playerCardId"]),
    betsSent() {
      const bets = Object.keys(this.getProcessingBets).map(
        (id) => this.getProcessingBets[id]
      );
      return bets.length > 0 ? bets : null;
    },
    betsProcessed() {
      const bets = Object.keys(this.getProcessedBets).map(
        (id) => this.getProcessedBets[id]
      );
      return bets.length > 0 ? bets : null;
    },
    betsProcessing() {
      return this.betsSent?.filter((bet) => bet.status === "pending") || null;
    },
    processing() {
      return this.betsProcessing?.length > 0;
    },
    betsCompleted() {
      console.log('betsCompleted',this.betsSent)
      return this.betsSent
        ?.filter((bet) => bet.status && bet.status !== "pending")
        ?.sort((a, b) => b.time - a.time)
        ?.sort((a) => {
          if (a.error) {
            return -1;
          }
        });
    },
    totalRequest() {
      return this.getBetSlip.reduce(
        (acc, item) => acc + parseFloat(item.stake),
        0
      );
    },
    betslip() {
      return mapBetSlip(this.getBetSlip);
    },
    totalRefund() {
    return (
      this?.betsCompleted
        ?.reduce((acc, curr) => {
          let total = acc + (parseFloat(curr.refundOwing) || 0);
          if (curr.status === 'rejected') {
            total += (parseFloat(curr.stake) || 0);
          }
          return total;
        }, 0.0)
        .toFixed(2) || null
      );
    },
    betsPrinted() {
      return this.getPrintedBets
    },
    allBetsPrinted() {
      console.log('allBetsPrinted', this.betsProcessed)
      const printed = this.betsProcessed?.filter((bet) => !!bet.printed);
      return printed?.length === this.betsProcessed?.length && !this.processing;
    },
    showPlayerCard() {
      if (PLAYERCARDACTIVE[this.$route.query.venue]) return true;
      return false;
    },
    isOverFlowing() {
      return this.betContainerClientHeight < this.betContainerScrollHeight;
    },
    isBetSlipOverFlowing() {
      return this.betSlipListElClientheight < this.betSlipListElScrollHeight
    },
    isBetSlipProcessedOverFlowing() {
      return this.betSlipProcessedElClientheight < this.betSlipProcessedElScrollHeight
    }
  },
  mounted() {
    // this.pollPrintQueue(),
    this.betContainerClientHeight = this.$refs.betContainerEl.clientHeight;
    this.betContainerScrollHeight = this.$refs.betContainerEl.scrollHeight;
    const ob = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.betContainerClientHeight = entry.target.clientHeight;
        this.betContainerScrollHeight = entry.target.scrollHeight;
      }
    });
    ob.observe(this.$refs.betContainerEl);
  },
  beforeDestroy() {
    clearInterval(this.checkBetPoll);
  },
  methods: {
    ...mapActions([
      "showBetModal",
      "setTerminalFail",
      "clearBets",
      "storePayment",
      "setProcessedBets",
      "clearPlayerCardId",
      "setProcessedBet",
      "clearSelectedBets",
      "setProcessingBets",
      "clearProcessingBets",
      "clearProcessedBets",
      "clearPrintedBets",
      "updateScannedTickets",
      "getTerminalToken"
    ]),
    ...mapMutations(["setPrintedBets"]),
    // pollPrintQueue() {
    //   setInterval(() => {
    //     if (!this.printing && Object.keys(this.printQueue)?.length > 0) {
    //       const bet = Object.values(this.printQueue)?.[0];
    //       this.printProcessedBet(bet);
    //       console.log('q', this.printing, this.printQueue);
    //     }
    //   }, 1000); // Poll every 1 second
    // },
    getBetsCompleted() {
      return this.betsCompleted || [];
    },
    betIsPrinted(bet) {
      const printedBets = Object.keys(this.getProcessedBets).map(
        (id) => this.getProcessedBets[id]
      );
      console.log(printedBets, bet)
      return printedBets.find((a) => a.key === bet.key)
    },
    potentialReturn(stake, odds) {
      const returnAmt = stake * odds;
      return (Math.floor(returnAmt * 100).toFixed(0) / 100).toFixed(2);
    },
    betype(v) {
      const display = PRICE_DISPLAY;
      const type = display.find(
        (c) => c.apiName === v && c.venueName === this.getVenueName
      )?.display;
      return type;
    },
    betPlatformType(v) {
      const display = PRICE_DISPLAY;
      const type = display.find(
        (c) => c.apiName === v && c.venueName === this.getVenueName
      )?.platformType;
      return type;
    },
    moment,
    formatStartTime: function (date) {
      return moment(date, "YYYY-MM-DD H:mm:ss").format("LLL");
    },
    openBetEditor(v) {
      (this.showBetEditor = true), (this.editBetId = v);
    },
    closeBetEditor() {
      (this.showBetEditor = false), (this.editBetId = null);
    },
    // checkBetType(type) {
    //   if (type === 's') {
    //     return 'p'
    //   }
    //   else return type
    // },
    ticketStatusName(v) {
      const name = NAMINGS;
      const status = name.find(
        (c) => c.word === v && c.venueName === this.getVenueName
      )?.replaceWith;
      return status || v;
    },
    async placeBet() {
      this.allowCancelPendingBets = false;
      (this.loadCircle = true), this.storePayment(this.totalRequest);
      const newbets = mapBetSlip(this.getBetSlip);
      newbets.forEach((bet) => {
        this.setProcessingBets({ ...bet, status: "pending" });
      });
      this.betsPlaced = true;
      newbets.forEach((bet, i) => {
        this.betTimeoutMap.push({
          key: bet.key,
          timeOut: setTimeout(() => {
            this.processBet(bet);
          }, i * 200),
        });
      });
      //allow to cancel pending bets after all bets tried once
      setTimeout(() => {
        this.allowCancelPendingBets = true;
      }, newbets.length * 1000 + 5000);
      this.showSendBets = true;
    },
    async resendBet(v) {
      this.allowCancelPendingBets = false;
      this.storePayment(this.totalRequest);
      this.betsPlaced = true;
      this.betTimeoutMap.push({
        key: v.key,
        timeOut: setTimeout(() => {
          this.processBet(v);
        }, 2000),
      });
      setTimeout(() => {
        this.allowCancelPendingBets = true;
      }, 2000 + 5000);
      this.showSendBets = true;
    },
    async processBet(bet) {
      console.log("processing bet", "trackName", bet?.trackName, "raceNumber", bet?.trackNumber, "raceName", bet?.raceName);
      //const startTime = moment(bet.startTime).format("ddd, hA");
      const token = await this.getTerminalToken()
      try {
        axios
          .post(
            `${process.env.VUE_APP_LEDGER_ENDPOINT}public/PlaceBet`,
            {
              terminal_id: token,
              //ticket_id: "string",
              idempotency_id: Date.now().toString(36) + Math.random().toString(36).substring(2),
              bet: {
                type: this.betPlatformType(bet.winPlc),
                platform: "fixed",
                //stake: parseInt(bet.stake * 100),
                //ticket_cost: parseInt(bet.stake * 100),
                //odds: parseInt(bet.odds * 100),
                stake: Math.round(bet.stake * 100),
                ticket_cost: Math.round(bet.stake * 100),
                odds: Math.round(bet.odds * 100),
                player_id: this.playerCardId,
                race_id: bet.raceId,
                race_meta: {
                  track_name: bet.trackName,
                  race_start: bet.startTime,
                  race_number: bet.trackNumber,
                  meeting_type: bet.meeting.type
                },
                legs: [
                  {
                    selections: [
                      {
                        "selection_id": bet.selId,
                        "selection_meta": {
                          name: bet.runnerName,
                          runner: bet.runnerNumber,

                        }
                      }
                    ]
                  }
                ]
              }

            },
          )
          .then((response) => {
            if (
              response?.data?.error &&
              response?.data?.error !== "Price has changed" &&
              response?.error !== "Price has changed"
            ) {
              const updatedBet = {
                ...bet,
                status: response?.data?.error,
                error: response?.data?.error,
                time: Date.now(),
                refundOwing: bet.stake,
              };
              this.setProcessingBets({bet: updatedBet, num: 2});
            }
            if (
              response?.data?.error === "Price has changed" ||
              response?.error === "Price has changed"
            ) {
              const updatedBet = {
                ...bet,
                status: response?.data?.error,
                error: response?.data?.error,
                time: Date.now(),
              };
              this.setProcessingBets({bet: updatedBet, num: 1});
            }
            if (
              response?.data?.detail?.status === "unresulted" &&
              this.hasFeature("cappedTickets")
            ) {
              console.log("bet response:", "raceName", response?.data?.detail?.raceName, "raceNumber", response?.data?.detail?.raceNumber, "meetingName", response?.data?.detail?.meetingName);              
              const updatedBet = {
                ...bet,
                status: response?.data?.detail?.status,
                id: response?.data?.detail?.id,
                ticketId: response?.data?.ticketId,
                time: response?.data?.timestamp,
                branchCap: response?.data?.branchCap,
                branch: response?.data?.masterBranch,
                capState: response?.data?.branchCapEnabled,
                trackName: response?.data?.detail?.raceName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '), //response is actually the meeting name "TURF PARADISE"
                trackNumber: response?.data?.detail?.raceNumber, 
                raceName: response?.data?.detail?.meetingName, // response is actually the race name  "Race 7 - Starter Allowance"
              };
              this.setProcessingBets({bet: updatedBet, num: 3});
            }
            if (
              response?.data?.detail?.status === "unresulted" &&
              !this.hasFeature("cappedTickets")
            ) {
              console.log("bet response:", "raceName", response?.data?.detail?.raceName, "raceNumber", response?.data?.detail?.raceNumber, "meetingName", response?.data?.detail?.meetingName);
              const updatedBet = {
                ...bet,
                status: response?.data?.detail?.status,
                id: response?.data?.detail?.id,
                ticketId: response?.data?.ticketId,
                time: response?.data?.timestamp,
                trackName: response?.data?.detail?.raceName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '), //response is actually the meeting name "TURF PARADISE"
                trackNumber: response?.data?.detail?.raceNumber, 
                raceName: response?.data?.detail?.meetingName, // response is actually the race name  "Race 7 - Starter Allowance"
              };
              this.setProcessingBets({bet: updatedBet, num: 4});
            }
            if (response?.data?.detail?.status === 'pending') {
              console.log('pending')
              console.log("bet response:", "raceName", response?.data?.detail?.raceName, "raceNumber", response?.data?.detail?.raceNumber, "meetingName", response?.data?.detail?.meetingName);
              const updatedBet = {
                ...bet,
                status: response?.data?.detail?.status,
                id: response?.data?.detail?.id,
                ticketId: response?.data?.ticketId,
                time: Date.now(),
                trackName: response?.data?.detail?.raceName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') ?? bet.trackName, 
                trackNumber: response?.data?.detail?.raceNumber ?? bet.trackNumber,
                raceName: response?.data?.detail?.meetingName ?? bet.raceName,
              }
              this.setProcessingBets({bet: updatedBet, num: 5});
              this.checkBets(this.betsProcessing)
            }
            // if (!response?.data?.error) {
            //   const updatedBet = {
            //     ...bet,
            //     status: response?.data?.details?.[0]?.status,
            //     id: response?.data?.details?.[0]?.id,
            //     ticketId: response?.data?.ticketId,
            //     error: response?.error,
            //     time: Date.now(),
            //     refundOwing: bet.stake
            //   }
            //   console.log(response)
            //   this.setProcessingBets(updatedBet)
            // }
          })
          .catch((err) => {
            console.log("err:");
            console.log(err);
            this.setProcessingBets({
              bet: {
                ...bet,
                status: "Bet failed",
                error: err?.data?.response || err,
                time: Date.now(),
                refundOwing: bet.stake,
              },
              num: 2,
            });
            // this.addTransaction(parseFloat(bet.stake), `Errored Bet Payment - ${err},  Runner name: ${bet.runnerName}, Race: ${bet.trackName}, R${bet.trackNumber}, selId: ${bet.selId}, stake - ${bet.stake}`, 2)
          });
      } catch (error) {
        console.log("error: ");
        console.log(error);
      }
    },
    // async pollBetStatus() {
    //   this.checkBetPoll = setInterval(() => {
    //     if (this.betsProcessing?.length > 0)
    //       this.checkBets(this.betsProcessing);
    //   }, 1000);
    // },
    async checkBets(bets) {
      const token = await this.getTerminalToken();

      const processPendingBet = async (index) => {
        if (index >= bets.length) {
          // If all bets have been processed, exit the recursion
          return;
        }

        const bet = bets[index];

        if (!bet.ticketId || bet.status !== 'pending') {
          // Skip bets without a ticketId or those that are not pending
          processPendingBet(index + 1); // Process the next bet
          return;
        }

        try {
          const response = await axios.post(
            `${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetTicket`,
            {
              terminal_id: token,
              ticket_id: bet.ticketId,
            }
          );

          if (response.data.detail.status === 'pending') {
            // If the response status is still 'pending', retry after a delay
            await new Promise((resolve) => setTimeout(resolve, 1000));
            processPendingBet(index); // Retry the same bet
          } else {
            console.log("bet response for check bets:", "raceName", response.data.detail.raceName, "raceNumber", response.data.detail.raceNumber, "meetingName", response.data.detail.meetingName);
            const updatedBet = {
              ...bet,
              status: response.data.detail.status,
              id: response.data.detail.id,
              ticketId: response.data.ticketId,
              error: response?.error,
              refundOwing: response.data?.balance,
              time: Date.now(),
              trackName: response.data.detail.raceName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') ?? bet.trackName, 
              trackNumber: response.data.detail.raceNumber ?? bet.trackNumber,
              raceName: response.data.detail.meetingName ?? bet.raceName
            };

            this.setProcessingBets({ bet: updatedBet, num: 6 });

            // Wait for 1 second before processing the next bet
            await new Promise((resolve) => setTimeout(resolve, 1000));

            // Process the next bet
            processPendingBet(index + 1);
          }
        } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 504) {
            // If it's a rate limit error (adjust the condition as needed)
            await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before retrying
          }

          // Retry the same bet after a delay
          await new Promise((resolve) => setTimeout(resolve, 1000));
          processPendingBet(index);
        }
      };

      // Start processing bets from index 0
      await processPendingBet(0);
    },
    scrollTop() {
      let content = document.querySelector(".betContainer");
      content.scrollTop -= 50;
    },
    scrollDown() {
      let content = document.querySelector(".betContainer");
      content.scrollTop += 50;
    },
    scrollBetSlipTop() {
      let content = document.querySelector(".betslipList");
      content.scrollTop -= 50;
    },
    scrollBetSlipDown() {
      let content = document.querySelector(".betslipList");
      content.scrollTop += 50;
    },
    scrollProcessedTop() {
      let content = document.querySelector(".betslipListProcessed");
      content.scrollTop -= 50;
    },
    scrollProcessedDown() {
      let content = document.querySelector(".betslipListProcessed");
      content.scrollTop += 50;
    },
    cancelBets() {
      this.loadCircle = true;
      this.checkMark = true;
      this.betMessage = "Bets cancelled";
      (this.showSendBets = false),
        (this.loadCircle = false),
        // this.clearStake(this.stake, v)
        (this.checkMark = false);
      this.betMessage = "";
      // this.processingBets = {}
      this.clearProcessingBets();
      this.clearProcessedBets();
      this.clearPrintedBets();
      this.betsPlaced = false;
      this.clearBets();
      this.clearPlayerCardId();
    },
    handleCancelBets() {
      if (this.betsPlaced && this.allBetsPrinted) this.cancelBets();
    },
    sendBets() {
      const bets = mapBetSlip(this.getBetSlip);
      if (bets !== 0) {
        this.showSendBets = true;
      } else {
        return null;
      }
    },
    addPrintQueue(data) {
      console.log('addPrintQueue', data)
      Vue.set(this.printQueue, data.key, data);
    },
    printProcessedBet(data) {
      this.setPrintedBets(data);
      this.printing = true;
      const keys = Object.keys(this.processingBets).filter(
        (key) => this.processingBets[key]?.key === data.key
      );
      const updatedBets = { ...this.processingBets };

      keys.forEach((key) => {
        if (updatedBets[key]) {
          updatedBets[key].printed = true;
        }
      });

      this.clearSelectedBets(keys);
      const updatedBet = {
        ...data,
        printed: true,
      };
      console.log(updatedBet);
      // this.setProcessedBet(updatedBets)
      // this.setProcessingBets(updatedBet)
      if (!data.ticketId) {
        console.log('no ID')
        this.updateBet(updatedBet, updatedBets)();
      }
      else if (window.rt?.printImage) {
        const startTime = this.formatStartTime(moment(updatedBet.startTime));
        window.rt
          .printImage(
            generateCustomerBetReceipt(
              updatedBet,
              this.getTerminalLocation,
              this.playerCardId,
              this.$route.query.venue,
              startTime
            )
          )
          .then(() => {
            console.log("customer bet receipt printed");
            if (updatedBet.refundOwing) {
              console.log("printing teller refund receipt");
              return window.rt.printImage(
                generateTellerRefundReceipt(
                  updatedBet,
                  this.getTerminalLocation,
                  this.playerCardId,
                  this.$route.query.venue,
                  startTime
                )
              );
            }
          })
          .then(() => {
            console.log(`printing complete`);
            this.updateBet(updatedBet, updatedBets)();
          })
          .catch((e) => {
            console.log(`Failed to print: ${e}`);
            this.printing = false;
          });
      } else {
        console.log('nextTick')
        Vue.nextTick(() => {
            window.onafterprint = this.updateBet(updatedBet, updatedBets);
            window.print();
        });
      }
    },
    updateBet(updatedBet, updatedBets) {
      return () => {
        this.setProcessedBet(updatedBet);
        this.setProcessingBets({bet: updatedBets, num: 7});
        Vue.delete(this.printQueue, updatedBet.key);
      };
    },
    clearProcessedBet(data) {
      const keys = Object.keys(this.processingBets).filter(
        (key) => this.processingBets[key]?.key === data.key
      );
      const updatedBets = { ...this.processingBets };
      keys.forEach((key) => {
        delete updatedBets[key];
      });
      this.setProcessedBets(updatedBets);
      this.clearSelectedBets(keys);
    },
    //start temporary poll checking cancel on exit of betslip modal
    cancelChecking() {
      this.cancelCheckBetPolling();
      this.clearStake(
        "cancelled",
        "Operator Cancelled",
        this.betId,
        this.error,
        this.refundBet,
        this.ticketId
      );
    },
    // end temporary poll checking cancel on exit of betslip modal
    cancelCheckBetPolling() {
      clearInterval(this.checkBetPoll);
      this.checkBetPoll = null;
    },
    cancelPendingBet(bet) {
      const timeoutItem = this.betTimeoutMap.find((m) => m.key == bet.key);
      clearTimeout(timeoutItem?.timeOut);
      bet.status = "cancelled";
      this.setProcessingBets(bet);
      //remove timeout from the map
      const idx = this.betTimeoutMap.findIndex((m) => m.key == bet.key);
      if (idx > -1) {
        this.betTimeoutMap.splice(idx, 1);
      }
    },
  },
  watch: {
    totalRequest(newVal) {
      updateCustomerDisplayStoredBets(this.getBetSlip.length, `$${newVal}`);
      this.$nextTick(() => {
        this.betContainerScrollHeight = this.$refs.betContainerEl?.scrollHeight;
      });
    },
    printQueue: {
      handler(newQueue) {
        const keys = Object.keys(newQueue);

        if (keys.length > 0) {
          const firstKey = keys[0];
          const bet = newQueue[firstKey];
          this.printProcessedBet(bet);
          // Remove the processed bet from the queue
          Vue.delete(this.printQueue, firstKey);
        }
      },
      deep: true,
    },
    showSendBets(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.betSlipListElClientheight = this.$refs.betSlipListEl.$el.clientHeight;
          this.betSlipListElScrollHeight = this.$refs.betSlipListEl.$el.scrollHeight;
          const ob = new ResizeObserver((entries) => {
            for (let entry of entries) {
              this.betSlipListElClientheight = entry.target.clientHeight;
              this.betSlipListElScrollHeight = entry.target.scrollHeight;
            }
          });
          ob.observe(this.$refs.betSlipListEl.$el);

          this.betSlipProcessedElClientheight = this.$refs.betSlipProcessedEl.$el.clientHeight;
          this.betSlipProcessedElScrollHeight = this.$refs.betSlipProcessedEl.$el.scrollHeight;
          const ob1 = new ResizeObserver((entries) => {
            for (let entry of entries) {
              this.betSlipProcessedElClientheight = entry.target.clientHeight;
              this.betSlipProcessedElScrollHeight = entry.target.scrollHeight;
            }
          });
          ob1.observe(this.$refs.betSlipProcessedEl.$el);
        })

      }
    },
    betsSent() {
      if (this.$refs.betSlipListEl) {
        this.betSlipListElClientheight = this.$refs.betSlipListEl.$el.clientHeight;
        this.betSlipListElScrollHeight = this.$refs.betSlipListEl.$el.scrollHeight;
      }

    },
    betsCompleted() {
      if (this.$refs.betSlipProcessedEl) {
        this.betSlipProcessedElClientheight = this.$refs.betSlipProcessedEl.$el.clientHeight;
        this.betSlipProcessedElScrollHeight = this.$refs.betSlipProcessedEl.$el.scrollHeight;
      }
    }
  },
};
</script>

<style scoped>
.raceIcon {
  transform: scale(0.6);
  position: absolute;
}

.raceTypeDiv {
  width: 20px;
  height: 20px;
}

.betslipList {
  overflow-y: scroll;
}

.betslipListProcessed {
  overflow-y: scroll;
}

.refund {
  color: red;
}
</style>
